import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Divider,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from "moment";
import { BASEURL } from "api/axiosInstance";

const RowItem = ({
  label,
  value,
  isBold = false,
  isRed = false,
  isGrey = false,
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      py: 0.5,
      px: 2,
    }}
  >
    <Typography
      variant={isBold ? "subtitle1" : "body1"}
      sx={{
        fontWeight: isBold ? "bold" : "normal",
        color: isRed
          ? "error.main"
          : isGrey
          ? "text.secondary"
          : "text.primary",
        flex: 1,
      }}
    >
      {label}
    </Typography>
    <Typography
      variant={isBold ? "subtitle1" : "body1"}
      sx={{
        fontWeight: isBold ? "bold" : "normal",
        color: isRed
          ? "error.main"
          : isGrey
          ? "text.secondary"
          : "text.primary",
        textAlign: "right",
        flex: 1,
      }}
    >
      {value}
    </Typography>
  </Box>
);
const formatRupiah = (amount) => {
  if (amount === null || amount === undefined) return "Rp 0";
  const isNegative = amount < 0;
  const absoluteAmount = Math.abs(amount);
  const formatted = absoluteAmount.toLocaleString("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return `Rp ${formatted}${isNegative ? " (-)" : ""}`;
};

const DetailSetoranModal = ({
  open,
  onClose,
  dataDetail,
  dataPengeluaran,
  onSubmit,
}) => {
  const [activeTab, setActiveTab] = React.useState("pendapatan");
  React.useState(false);

  const defaultPecahanState = {
    seratus: "",
    limapuluh: "",
    duapuluh: "",
    sepuluh: "",
    limaribu: "",
    duaribu: "",
    seribu: "",
    coin: "",
  };

  const [pendapatan, setPendapatan] = React.useState({
    ...defaultPecahanState,
    list_pendapatan: [],
  });

  const [pengeluaran, setPengeluaran] = React.useState({
    ...defaultPecahanState,
    list_pengeluaran: [],
  });

  const mapValueToCount = (value, nominal) =>
    value ? (value / nominal).toString() : "";

  React.useEffect(() => {
    if (!open || !dataPengeluaran) return;
    const dataPendapatan = dataPengeluaran.list_pendapatan;
    if (dataPendapatan && dataPendapatan.tipe === "pendapatan") {
      const loadedPecahan = {
        seratus: mapValueToCount(dataPendapatan.seratus, 100000),
        limapuluh: mapValueToCount(dataPendapatan.limapuluh, 50000),
        duapuluh: mapValueToCount(dataPendapatan.duapuluh, 20000),
        sepuluh: mapValueToCount(dataPendapatan.sepuluh, 10000),
        limaribu: mapValueToCount(dataPendapatan.limaribu, 5000),
        duaribu: mapValueToCount(dataPendapatan.duaribu, 2000),
        seribu: mapValueToCount(dataPendapatan.seribu, 1000),
        coin: dataPendapatan.coin != null ? String(dataPendapatan.coin) : "",
      };

      const parsedList = deserializeList(dataPendapatan.list ?? "");
      setPendapatan({
        ...loadedPecahan,
        list_pendapatan: parsedList,
      });
    } else {
      setPendapatan({ ...defaultPecahanState, list_pendapatan: [] });
    }
    const dataPengeluaranData = dataPengeluaran.list_pengeluaran;
    if (dataPengeluaranData && dataPengeluaranData.tipe === "pengeluaran") {
      const loadedPecahan = {
        seratus: mapValueToCount(dataPengeluaranData.seratus, 100000),
        limapuluh: mapValueToCount(dataPengeluaranData.limapuluh, 50000),
        duapuluh: mapValueToCount(dataPengeluaranData.duapuluh, 20000),
        sepuluh: mapValueToCount(dataPengeluaranData.sepuluh, 10000),
        limaribu: mapValueToCount(dataPengeluaranData.limaribu, 5000),
        duaribu: mapValueToCount(dataPengeluaranData.duaribu, 2000),
        seribu: mapValueToCount(dataPengeluaranData.seribu, 1000),
        coin:
          dataPengeluaranData.coin != null
            ? String(dataPengeluaranData.coin)
            : "",
      };

      const parsedList = deserializeList(dataPengeluaranData.list ?? "");
      setPengeluaran({
        ...loadedPecahan,
        list_pengeluaran: parsedList,
      });
    } else {
      setPengeluaran({ ...defaultPecahanState, list_pengeluaran: [] });
    }
  }, [dataPengeluaran, open]);

  const handleAddList = (tab) => {
    if (tab === "pendapatan") {
      setPendapatan((prev) => ({
        ...prev,
        list_pendapatan: [
          ...prev.list_pendapatan,
          { keterangan: "", value: 0 },
        ],
      }));
    } else {
      setPengeluaran((prev) => ({
        ...prev,
        list_pengeluaran: [
          ...prev.list_pengeluaran,
          { keterangan: "", value: 0 },
        ],
      }));
    }
  };

  const handleChangeList = (tab, idx, field, newValue) => {
    if (tab === "pendapatan") {
      const updated = [...pendapatan.list_pendapatan];
      updated[idx][field] =
        field === "value" ? Number(newValue) || 0 : newValue;
      setPendapatan((prev) => ({ ...prev, list_pendapatan: updated }));
    } else {
      const updated = [...pengeluaran.list_pengeluaran];
      updated[idx][field] =
        field === "value" ? Number(newValue) || 0 : newValue;
      setPengeluaran((prev) => ({ ...prev, list_pengeluaran: updated }));
    }
  };

  const handleRemoveList = (tab, idx) => {
    if (tab === "pendapatan") {
      const updated = [...pendapatan.list_pendapatan];
      updated.splice(idx, 1);
      setPendapatan((prev) => ({ ...prev, list_pendapatan: updated }));
    } else {
      const updated = [...pengeluaran.list_pengeluaran];
      updated.splice(idx, 1);
      setPengeluaran((prev) => ({ ...prev, list_pengeluaran: updated }));
    }
  };

  const hitungTotalList = (obj) => {
    const listKey = obj.list_pendapatan
      ? "list_pendapatan"
      : "list_pengeluaran";
    return (obj[listKey] || []).reduce(
      (acc, item) => acc + (Number(item.value) || 0),
      0
    );
  };

  const hitungTotalPecahan = (obj) => {
    const pecahanMap = {
      seratus: 100000,
      limapuluh: 50000,
      duapuluh: 20000,
      sepuluh: 10000,
      limaribu: 5000,
      duaribu: 2000,
      seribu: 1000,
    };

    const totalKertas = Object.entries(pecahanMap).reduce(
      (acc, [key, val]) => acc + (parseInt(obj[key] || 0) * val || 0),
      0
    );

    return totalKertas + parseInt(obj.coin || 0);
  };

  const currentData = activeTab === "pendapatan" ? pendapatan : pengeluaran;

  const totalPecahan = hitungTotalPecahan(currentData);
  const totalList = hitungTotalList(currentData);

  const isValid = totalPecahan === totalList && totalPecahan > 0;

  const serializeList = (list) => {
    if (!Array.isArray(list)) return "";
    return list
      .filter((item) => item.keterangan && typeof item.value === "number")
      .map((item) => `${item.keterangan}: ${item.value}`)
      .join("; ");
  };
  const deserializeList = (str) => {
    if (!str || typeof str !== "string") {
      return [];
    }
    return str
      .split(";")
      .map((item) => item.trim())
      .filter((item) => item.length > 0)
      .map((item) => {
        const colonIndex = item.lastIndexOf(":");
        if (colonIndex === -1) return null;
        const keterangan = item.substring(0, colonIndex).trim();
        const valueStr = item.substring(colonIndex + 1).trim();
        let value = parseFloat(
          valueStr.replace(/[.,]/g, (match, offset, string) => {
            return "";
          })
        );
        if (isNaN(value)) value = 0;
        return { keterangan, value };
      })
      .filter((item) => item !== null && item.keterangan !== "");
  };

  const [hasSignificantNegativeSelisih, setHasSignificantNegativeSelisih] =
    React.useState(false);

  React.useEffect(() => {
    if (
      !dataDetail?.original_data ||
      !Array.isArray(dataDetail.original_data)
    ) {
      setHasSignificantNegativeSelisih(false);
      return;
    }
    const isError = dataDetail.original_data.some((item) => {
      const calc =
        item.rp_omzet_kasir +
        item.rp_debit_credit +
        item.rp_ewallet +
        item.rp_pengeluaran;
      const selisih = calc - item.rp_omzet_data;

      return selisih <= -5000;
    });
    setHasSignificantNegativeSelisih(isError);
  }, [dataDetail]);

  const handleChange = (e, tab) => {
    const { name, value } = e.target;
    const cleanValue = value.replace(/\D/g, "");
    if (tab === "pendapatan") {
      setPendapatan((prev) => ({ ...prev, [name]: cleanValue }));
    } else {
      setPengeluaran((prev) => ({ ...prev, [name]: cleanValue }));
    }
  };

  const isDataChanged = React.useCallback(() => {
    const dataAwal =
      activeTab === "pendapatan"
        ? dataPengeluaran?.list_pendapatan
        : dataPengeluaran?.list_pengeluaran;
    if (!dataAwal) {
      return totalPecahan > 0 || totalList > 0;
    }
    const stateSekarang = activeTab === "pendapatan" ? pendapatan : pengeluaran;
    const nominalMap = {
      seratus: 100000,
      limapuluh: 50000,
      duapuluh: 20000,
      sepuluh: 10000,
      limaribu: 5000,
      duaribu: 2000,
      seribu: 1000,
    };
    const isPecahanChanged = Object.entries(nominalMap).some(
      ([key, nominal]) => {
        const stateValue = Number(stateSekarang[key] || 0) * nominal;
        const initialValue = dataAwal[key] || 0;
        return stateValue !== initialValue;
      }
    );
    const isCoinChanged =
      Number(stateSekarang.coin || 0) !== (dataAwal.coin || 0);
    const currentList =
      activeTab === "pendapatan"
        ? stateSekarang.list_pendapatan
        : stateSekarang.list_pengeluaran;

    const stateListSerialized = serializeList(currentList || []);
    const initialList = dataAwal.list ?? "";

    const isListChanged = stateListSerialized !== initialList;

    return isPecahanChanged || isCoinChanged || isListChanged;
  }, [
    activeTab,
    pendapatan,
    pengeluaran,
    dataPengeluaran,
    totalPecahan,
    totalList,
    serializeList,
  ]);
  const isEditMode =
    activeTab === "pendapatan"
      ? !!dataPengeluaran?.list_pendapatan
      : !!dataPengeluaran?.list_pengeluaran;
  const isApprovalMode =
    !isEditMode && dataDetail?.status === "belum_disetujui";
  const isApproveAction = isApprovalMode && !hasSignificantNegativeSelisih;
  const dataIsChanged = isDataChanged();
  const isReadyToSubmit = React.useMemo(() => {
    if (isApproveAction) return true;
    if (!isValid) return false;
    return dataIsChanged;
  }, [isApproveAction, isValid, dataIsChanged]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          DETAIL SETORAN TUNAI
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {dataDetail?.nama_cab} - {dataDetail?.id_cab}
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          {dataDetail?.id_karyawan} - {dataDetail?.nama_karyawan}
        </Typography>
        <Typography variant="body1" sx={{ mb: 0.5 }}>
          <strong>Sinkron:</strong>{" "}
          {dataDetail?.tgl_kas &&
            moment(dataDetail?.tgl_kas).format("DD MMMM YYYY")}
        </Typography>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ px: 1 }}>
          <RowItem
            label="Jumlah Kasir"
            value={dataDetail?.original_data?.length?.toString() || "0"}
          />
          <RowItem
            label="Uang Cash"
            value={formatRupiah(dataDetail?.nominal_setoran)}
            isBold
          />
          <RowItem
            label="STL"
            value={
              dataDetail?.is_stl ? formatRupiah(dataDetail.total_stl) : "-"
            }
          />
          <RowItem
            label="EDC Machine"
            value={
              dataDetail?.is_edc
                ? formatRupiah(dataDetail.total_debit_credit)
                : "-"
            }
          />
          <RowItem
            label="Qris"
            value={
              dataDetail?.is_qris ? formatRupiah(dataDetail.total_ewallet) : "-"
            }
          />
          <RowItem
            label="Pengeluaran"
            value={
              dataDetail?.is_pengeluaran
                ? formatRupiah(dataDetail.total_pengeluaran)
                : "-"
            }
          />
          <Divider />
        </Box>
        <Box sx={{ px: 1 }}>
          <RowItem
            label="Subtotal Omzet"
            value={formatRupiah(dataDetail?.subtotal_kasir)}
            isBold
          />
          {dataDetail?.original_data?.map((item, index) => {
            const calc =
              item.rp_omzet_kasir +
              item.rp_debit_credit +
              item.rp_ewallet +
              item.rp_pengeluaran;
            const selisih = calc - item.rp_omzet_data;
            return (
              <RowItem
                key={index}
                label={`Selisih ${item.opr}`}
                value={formatRupiah(selisih)}
                isRed={selisih < 0}
              />
            );
          })}
          <RowItem
            label="Total Omzet"
            value={formatRupiah(dataDetail?.total_omzet_data)}
            isBold
          />
          <Divider sx={{ my: 0.5 }} />
        </Box>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: "bold" }}>Rincian Pecahan</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 0 }}>
            <>
              <RowItem
                label="Pecahan 100rb"
                value={dataDetail?.seratus / 100000}
              />
              <RowItem
                label="Pecahan 50rb"
                value={dataDetail?.limapuluh / 50000}
              />
              <RowItem
                label="Pecahan 20rb"
                value={dataDetail?.duapuluh / 20000}
              />
              <RowItem
                label="Pecahan 10rb"
                value={dataDetail?.sepuluh / 10000}
              />
              <RowItem
                label="Pecahan 5rb"
                value={dataDetail?.limaribu / 5000}
              />
              <RowItem label="Pecahan 2rb" value={dataDetail?.duaribu / 2000} />
              <RowItem label="Pecahan 1rb" value={dataDetail?.seribu / 1000} />
              <RowItem
                label="Pecahan Coin"
                value={formatRupiah(dataDetail?.coin)}
              />
            </>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: "bold" }}>Catatan</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1" sx={{ mb: 0.5 }}>
              <strong>Note STL:</strong> {dataDetail?.list_stl ?? "-"}
            </Typography>
            <Typography variant="body1" sx={{ mb: 0.5 }}>
              <strong>Note EDC:</strong> {dataDetail?.is_edc ? "Ya" : "Tidak"}
            </Typography>
            <Typography variant="body1" sx={{ mb: 0.5 }}>
              <strong>Note Qris:</strong> {dataDetail?.is_qris ? "Ya" : "Tidak"}
            </Typography>
            <Typography variant="body1" sx={{ mb: 0.5 }}>
              <strong>Note Pengeluaran:</strong>{" "}
              {dataDetail?.list_pengeluaran ?? "-"}
            </Typography>
            {dataDetail?.original_data?.length > 0 &&
              dataDetail?.original_data?.map((item, index) => {
                return (
                  <Typography key={`kembalian-${index}`} variant="body1">
                    <span
                      style={{ color: "#000" }}
                    >{`Kembali Uang ${item.opr}:`}</span>{" "}
                    <span style={{ color: "#888" }}>
                      {item.rp_ku == 0 ? "Rp. 0" : formatRupiah(item.rp_ku)}
                    </span>
                  </Typography>
                );
              })}
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: "bold" }}>
              Pendapatan & Pengeluaran
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DialogTitle sx={{ textAlign: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "2px solid",
                  borderColor: "divider",
                }}
              >
                <Box
                  onClick={() => setActiveTab("pendapatan")}
                  sx={{
                    flex: 1,
                    textAlign: "center",
                    cursor: "pointer",
                    color:
                      activeTab === "pendapatan"
                        ? "success.main"
                        : "text.secondary",
                    fontWeight: activeTab === "pendapatan" ? "bold" : "normal",
                    pb: 1,
                    borderBottom:
                      activeTab === "pendapatan" ? "2px solid" : "none",
                    borderColor: "success.main",
                  }}
                >
                  <Typography variant="subtitle1">PENDAPATAN</Typography>
                </Box>

                <Box
                  onClick={() => setActiveTab("pengeluaran")}
                  sx={{
                    flex: 1,
                    textAlign: "center",
                    cursor: "pointer",
                    color:
                      activeTab === "pengeluaran"
                        ? "error.main"
                        : "text.secondary",
                    fontWeight: activeTab === "pengeluaran" ? "bold" : "normal",
                    pb: 1,
                    borderBottom:
                      activeTab === "pengeluaran" ? "2px solid" : "none",
                    borderColor: "error.main",
                  }}
                >
                  <Typography variant="subtitle1">PENGELUARAN</Typography>
                </Box>
              </Box>
            </DialogTitle>
            <Box>
              <Grid container spacing={1}>
                {[
                  { key: "seratus", label: "Pecahan 100" },
                  { key: "limaribu", label: "Pecahan 5" },
                  { key: "limapuluh", label: "Pecahan 50" },
                  { key: "duaribu", label: "Pecahan 2" },
                  { key: "duapuluh", label: "Pecahan 20" },
                  { key: "seribu", label: "Pecahan 1" },
                  { key: "sepuluh", label: "Pecahan 10" },
                  { key: "coin", label: "Pecahan Coin" },
                ].map((item, index, pecahan) => {
                  const isLeft = index % 2 === 0;
                  const currentTabData =
                    activeTab === "pendapatan" ? pendapatan : pengeluaran;
                  const handleTabChange = (e) => handleChange(e, activeTab);
                  return (
                    isLeft && (
                      <React.Fragment key={item.key}>
                        <Grid item xs={6}>
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            {item.label}
                          </Typography>
                          <TextField
                            name={item.key}
                            size="small"
                            fullWidth
                            value={currentTabData[item.key] || ""}
                            onChange={handleTabChange}
                            inputProps={{
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                            }}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          {pecahan[index + 1] && (
                            <>
                              <Typography variant="body2" sx={{ mb: 0.5 }}>
                                {pecahan[index + 1].label}
                              </Typography>
                              <TextField
                                name={pecahan[index + 1].key}
                                size="small"
                                fullWidth
                                value={
                                  currentTabData[pecahan[index + 1].key] || ""
                                }
                                onChange={handleTabChange}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                              />
                            </>
                          )}
                        </Grid>
                      </React.Fragment>
                    )
                  );
                })}
              </Grid>
            </Box>
            <Box sx={{ mt: 1 }}>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                mb={1}
                color={
                  activeTab === "pendapatan" ? "success.main" : "error.main"
                }
              >
                LIST
              </Typography>

              {(activeTab === "pendapatan"
                ? pendapatan.list_pendapatan
                : pengeluaran.list_pengeluaran
              ).map((item, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    gap: 1,
                    mb: 1,
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    fullWidth
                    size="small"
                    label="Keterangan"
                    value={item.keterangan}
                    onChange={(e) =>
                      handleChangeList(
                        activeTab,
                        idx,
                        "keterangan",
                        e.target.value
                      )
                    }
                  />

                  <TextField
                    size="small"
                    fullWidth
                    value={item.value}
                    onChange={(e) =>
                      handleChangeList(activeTab, idx, "value", e.target.value)
                    }
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}
                  />
                  <Button
                    size="small"
                    color="error"
                    variant="outlined"
                    onClick={() => handleRemoveList(activeTab, idx)}
                  >
                    Hapus
                  </Button>
                </Box>
              ))}

              <Button
                fullWidth
                size="small"
                variant="contained"
                onClick={() => handleAddList(activeTab)}
              >
                {`+ Tambah List ${
                  activeTab === "pendapatan" ? "Pendapatan" : "Pengeluaran"
                }`}
              </Button>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2">
                {`💵 ${
                  activeTab === "pendapatan"
                    ? "Total Pendapatan: "
                    : "Total Pengeluaran: "
                } Rp ${totalPecahan.toLocaleString()}`}
              </Typography>
              <Typography variant="body2">
                🧾 Total List: Rp {totalList.toLocaleString()}
              </Typography>
            </Box>
            <Button
              fullWidth
              sx={{ mt: 2 }}
              variant="contained"
              color={isReadyToSubmit ? "success" : "error"}
              disabled={!isReadyToSubmit}
              onClick={() => {
                const currentDataList =
                  activeTab === "pendapatan"
                    ? dataPengeluaran?.list_pendapatan
                    : dataPengeluaran?.list_pengeluaran;

                const finalPayload = {
                  ...(dataPengeluaran &&
                    currentDataList && { id: currentDataList.id }),

                  id_cab:
                    activeTab === "pendapatan" ? dataDetail?.id_cab : null,
                  nama_cab:
                    activeTab === "pendapatan" ? dataDetail?.nama_cab : null,
                  seratus: Number(currentData.seratus || 0) * 100000,
                  limapuluh: Number(currentData.limapuluh || 0) * 50000,
                  duapuluh: Number(currentData.duapuluh || 0) * 20000,
                  sepuluh: Number(currentData.sepuluh || 0) * 10000,
                  limaribu: Number(currentData.limaribu || 0) * 5000,
                  duaribu: Number(currentData.duaribu || 0) * 2000,
                  seribu: Number(currentData.seribu || 0) * 1000,
                  coin: Number(currentData.coin || 0),
                  transfer: 0,
                  nominal: hitungTotalPecahan(currentData),
                  list: serializeList(
                    activeTab === "pendapatan"
                      ? pendapatan.list_pendapatan
                      : pengeluaran.list_pengeluaran
                  ),
                  tipe: activeTab,
                  waktu_setoran: dataDetail?.waktu_setoran,
                  tgl_kas: dataDetail?.tgl_kas,
                };
                const justApprove = isApproveAction ? true : false;
                onSubmit(finalPayload, justApprove);
              }}
            >
              {isApproveAction ? "SETUJUI" : isEditMode ? "UBAH" : "SIMPAN"}
            </Button>
          </AccordionDetails>
        </Accordion>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          p: 2,
          borderTop: "1px solid",
          borderColor: "divider",
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            fontWeight: "bold",
            flexGrow: 1,
            backgroundColor: (theme) => theme.palette.grey[300],
            color: (theme) => theme.palette.text.primary,
            "&:hover": {
              backgroundColor: (theme) => theme.palette.grey[400],
            },
          }}
        >
          TUTUP
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetailSetoranModal;
